import axios from "axios";

const DETAIL_URL = process.env.REACT_APP_ASSESS_API_BASEURL;

export const getMyDetails = async () => {
  const token = localStorage.getItem("token");

  const response = await axios.get(`${DETAIL_URL}users/my-details`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    withCredentials: true,
  });

  return response.data;
};
